import React from 'react';
import { Carousel } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import { useNavigate } from 'react-router';

const Markting = () => {

    const navigate = useNavigate();

    const Goback = () => {
        navigate('/home')
    }

    return (
        <div>
              <div className="container mt-5 pageColor">
                <h3 style={{cursor:"pointer"}} onClick={Goback} className="fs-4  text-white fw-bolder">← Back </h3>
                
                <h1 className="text-center p-5 text-white fw-bolder"> Marketing Idea Details .</h1>
               
{/* ------------------------------  */}
            
 <Carousel  style={{ textAlign:'center'}}  fade>
  <Carousel.Item className="container">
    <img
      className="d-block w-100"
      src="https://i.ibb.co/sVNDJ6B/1.png"
      alt="First slide"
    />
    <Carousel.Caption>
     
    </Carousel.Caption>
  </Carousel.Item>
  <Carousel.Item>
    <img
      className="d-block w-100"
      src="https://i.ibb.co/RT2PFMX/2.png"
      alt="Second slide"
    />

    <Carousel.Caption>
     
    </Carousel.Caption>
  </Carousel.Item>
  <Carousel.Item>
    <img
      className="d-block w-100"
      src="https://i.ibb.co/tbQNGrp/3.png"
      alt="Third slide"
    />

    <Carousel.Caption>
    </Carousel.Caption>
  </Carousel.Item>
 </Carousel>
{/* ------------------------------  */}

          <br />  
          <br />  
          <br />
          <h5 className="ps-2 text-white"> This is Markting Base website . Technologies use : React js,  Bootstrap, React Router, Node js,   it's Fully Responsive . Live link Click here to visit the page: PH-Travel , Client side Github Link: Go to Github client side  repository .Thanks ....
        </h5>  
        
        <br />
            <div className=" grid-button d-flex justify-content-center p-5  ">
                    <a className= " box btn  text-primary    fw-bolder " href="https://github.com/RonyMiah/Apple-Website-Client-Side"> Client side  </a>
                    <a className= " box btn  text-primary    fw-bolder " href="https://github.com/RonyMiah/Apple-Website-Server-Side"> Server side  </a>
                        
                        <a className=" box btn  text-primary    fw-bolder " href="https://apple-product-69484.web.app/"> Live site </a>
                        <NavLink className=" box btn  text-primary    fw-bolder " to="/blogs"> Blogs </NavLink>
            </div>

        </div>
        </div>
    );
};

export default Markting;